export default "__VITE_ASSET__debefb3c__"